
import { useSelectedProducts } from './useSelectedProducts';
import { useEditingState } from './useEditingState';

export const useProductSelection = () => {
  // Get product selection state and functions
  const {
    selectedProducts,
    toggleProductSelection,
    toggleSelectAll,
    areAllSelected
  } = useSelectedProducts();

  // Get editing state and functions
  const {
    editingProductId,
    addingProduct,
    setAddingProduct,
    handleEditProduct,
    handleAddProductForm,
    handleCloseForm,
    setEditingProductId
  } = useEditingState();

  return {
    selectedProducts,
    editingProductId,
    addingProduct,
    setAddingProduct,
    toggleProductSelection,
    toggleSelectAll,
    areAllSelected,
    handleEditProduct,
    handleAddProductForm,
    handleCloseForm,
    setEditingProductId
  };
};
